<section class="new-car-details">
  <header class="hero">
    <div class="hero-background"></div>
    <div class="hero-content">
      <div class="hero-header">
        <h1 class="hero-title">New Railcar Builds</h1>
        <i id="close-icon" (click)="closeModel()" class="pi pi-times"></i>
      </div>
      <h2 class="hero-subtitle">covered hopper</h2>
    </div>
  </header>

  <main class="main-content">
    <section class="product-info">
      <h3 class="product-title">
        {{ carDetails?.model_desc }}
      </h3>
      <div class="product-options">
        <div class="option">
          <h4 class="option-title">Option 1</h4>
          <p class="option-detail">Something</p>
        </div>
        <div class="option">
          <h4 class="option-title">Option 2</h4>
          <p class="option-detail">Something</p>
        </div>
        <div class="option">
          <h4 class="option-title">Option 3</h4>
          <p class="option-detail">Something</p>
        </div>
      </div>
    </section>
  </main>

  <main class="main-content-desc">
    <p class="product-description">
      {{ carDetails?.car_overview }}
    </p>
    <section class="features">
      <div class="feature">
        <h4 class="feature-title">Open barrel construction</h4>
        <p class="feature-description">
          Car does not have partition sheets, which facilitates ease of
          unloading and allows for a more complete cleanout.
        </p>
      </div>
      <div class="feature">
        <h4 class="feature-title">Closed loop unloading system</h4>
        <p class="feature-description">
          Product discharge swing "y" piping is located near the cars' center
          for operator convenience. Variable piping configurations are available
          with tamper-evidence provisions.
        </p>
      </div>
      <div class="feature">
        <h4 class="feature-title">History of industry leadership</h4>
        <p class="feature-description">
          TrinityRail™ has a long history as a leader in the innovation and
          design of covered hoppers designed to help you move and unload your
          products quickly and more efficiently.
        </p>
      </div>
      <div class="feature">
        <h4 class="feature-title">TrinityRail</h4>
        <p class="feature-description">
          TrinityRail™ offers trusted expertise and innovative rail products
          and services for true supply chain optimization.
        </p>
      </div>
    </section>
  </main>
  <section class="hopper-details">
    <div class="hopper-image-container">
      <p class="attributes">attributes</p>
      <img
        loading="lazy"
        src="assets/images/attr.svg"
        alt="Hopper image"
        class="hopper-image"
      />
      <div class="details-grid">
        <div class="details-column">
          <div class="detail-item">
            <h3 class="detail-label">capacity (Cubic feet)</h3>
            <p class="detail-value">{{ carDetails?.capacity }}</p>
          </div>
          <div class="detail-item">
            <h3 class="detail-label">gate type</h3>
            <p class="detail-value">{{ carDetails?.gate_type }}</p>
          </div>
          <div class="detail-item">
            <h3 class="detail-label">compartment QTY</h3>
            <p class="detail-value">{{ carDetails?.count }}</p>
          </div>
        </div>
        <div class="details-column">
          <div class="detail-item">
            <h3 class="detail-label">hatch cover</h3>
            <p class="detail-value">{{ carDetails?.hatch_cover }}</p>
          </div>
          <div class="detail-item">
            <h3 class="detail-label">Gravity Gate Size</h3>
            <p class="detail-value">{{ carDetails?.gate_size }}</p>
          </div>
          <div class="detail-item">
            <h3 class="detail-label">Gross Rail Load</h3>
            <p class="detail-value">{{ carDetails?.gross_rail_load }}</p>
          </div>
        </div>
      </div>
    </div>
    <button
      *ngIf="showBegin"
      class="quote-button"
      (click)="beginQuoteRequest(carDetails)"
    >
      begin quote request
    </button>
  </section>
</section>
